
export class Constant {
  // cookies key start
  public static KEY_CUSTOMER: string =  'customer' // same for local storage also
  public static KEY_USERNAME: string = 'username'
  public static KEY_LANGUAGE: string = 'language'
  public static KEY_TOKEN: string = 'token'
  public static KEY_LOGIN: string = 'login'
  public static KEY_SUPERVISORLOGIN: string = 'supervisorlogin'
  public static KEY_CDISELECTEDLANGUAGE: string = 'cdiSelectedLanguage'
  public static KEY_TOPSELLINGITEM: string = 'topSellingItems'  // same for local storage also
  public static KEY_FILTERDATA: string = 'filterData'
  public static KEY_LASTSYNCTIMESTAMP: string = 'lastSyncTimestamp'
  public static KEY_SEARCH: string = 'searchKey'
  public static KEY_SEARCHRESULTS: string =  'searchResults'
  public static KEY_LOGINSTATUS: string = 'loginStatus'
  public static KEY_LITERALS: string = 'literals'
  public static KEY_ORDERDATA: string = 'orderdata'
  public static KEY_INVOICEDATA: string = 'invoicedata'
  // cookies key end
  //local storage keys start
  public static KEY_CARTITEMS: string ='cartItems'
  //local storage keys end 
  //headers start
  public static HEADER_LANG_ID: string = "lang_id"
  public static HEADER_CONTENT_TYPE: string = "Content-Type"
  public static HEADER_ACCESS_CONTROL_ALLOW_ORIGIN: string ="Access-Control-Allow-Origin"
  public static HEADER_ACCESS_CONTROL_ALLOW_HEADERS: string = "Access-Control-Allow-Headers"
  public static HEADER_TOKEN: string = "token"

  //headers end
};


// WEBPACK FOOTER //
// ./src/app/Constant.ts